// frontend/src/components/NavBar.js

import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

function NavBar({ projectId, activeTab, setActiveTab }) {
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ 
      bgcolor: 'background.paper',
      boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
      mb: 3,
      '& .MuiTabs-root': {
        width: '60%',
        margin: '0 auto',
        '& .MuiTabs-indicator': {
          backgroundColor: '#007bff'
        }
      },
      '& .MuiTab-root': {
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 'normal',
        color: '#555',
        '&.Mui-selected': {
          color: '#007bff',
          fontWeight: 'normal'
        }
      }
    }}>
      <Tabs 
        value={activeTab}
        onChange={handleChange}
        variant="fullWidth"
        textColor="inherit"
      >
        <Tab value="create" label="Create" />
        <Tab value="share" label="Share" />
        <Tab value="monitor" label="Monitor" />
        <Tab value="analyze" label="Analyze" />
      </Tabs>
    </Box>
  );
}

export default NavBar;